export default __webpack_public_path__ + "static/grid-breakpoints-dark-1d341a796cb33bcc21b452d135411ccfabe0a0004a59826f3576730d3b7eef97.png";